<template>
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000247')"
					:inputValue="plantCd_"
					:options="plants_"
					:onChange="value => onChange({ key: 'plantCd', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000250')"
					:inputValue="serviceKind_"
					:options="serviceKinds_"
					:onChange="value => onChange({ key: 'serviceKind', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000283')"
					:inputValue="procType_"
					:options="procTypes_"
					:onChange="value => onChange({ key: 'procType', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-input-group :label="getMessage_('SWCC000284')" :inputValue="procId_" :onChange="value => onChange({ key: 'procId', value })" />
			</el-col>
			<el-col :span="4">
				<sf-input-group
					:label="getMessage_('SWCC000285')"
					:inputValue="procName_"
					:onChange="value => onChange({ key: 'procName', value })"
				/>
			</el-col>
		</el-row>
		<template slot="button">
			<sf-button v-if="isButton_(scrId, 'CR')" line :onClick="findAllProcesses"
				><i class="icon-sf-search"></i>{{ getMessage_('SWCC000244') }}</sf-button
			>
		</template>
	</sf-search-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/ProcessRegistration/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onChange({ key, value }) {
			this.DEFAULT_ASSIGN({
				key: 'searchParams',
				value: {
					...this.searchParams,
					[key]: value
				}
			});
		},
		findAllProcesses() {
			this.$sf_toggleLoading(true);
			this.fetchProcesses_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }).finally(() =>
				this.$sf_toggleLoading(false)
			);
		}
	},
	created() {
		this.$sf_toggleLoading(true);
		this.fetchPlants_()
			.then(() => this.fetchServiceKinds_({ plantCd: this.user.plantCd }))
			.then(() => this.fetchProcTypes_({ plantCd: this.user.plantCd }))
			.then(() => this.fetchProcKinds_({ plantCd: this.user.plantCd }))
			// .then(() => this.fetchOutputDevices_({ plantCd: this.user.plantCd }))
			// .then(() => this.fetchInputDevices_({ plantCd: this.user.plantCd }))
			.then(() => this.DEFAULT_ASSIGN({ key: 'searchParams', value: { ...this.searchParams, plantCd: this.user.plantCd } }))
			.finally(() => this.$sf_toggleLoading(false));
	},
	watch: {
		// TODO
		serviceKind_() {
			this.findAllProcesses();
		},
		procType_() {
			this.findAllProcesses();
		}
		// procId_() {
		// 	this.findAllProcesses();
		// },
		// procName_() {
		// 	this.findAllProcesses();
		// }
	}
};
</script>

<style langType="scss"></style>
